export const getLocalCurrency = (locale: string | undefined) => {
  const currency: Record<string, string> = {
    nz: 'NZD',
    ca: 'CAD',
    au: 'AUD',
    international: 'USD'
  };

  if (locale == null) {
    return 'AUD';
  }

  return currency[locale];
};
